import { useHandler } from "@redotech/react-util/hook";
import { REDO_REVIEW_HASH } from "@redotech/redo-model/storefront/navigation";
import { Flex } from "@redotech/redo-web/flex";
import { UploaderContext } from "@redotech/redo-web/image-upload";
import { Page } from "@redotech/redo-web/reviews-form/review-form";
import {
  PossibleSubmittableData,
  ReviewsFormValue,
} from "@redotech/redo-web/reviews-form/review-form-types";
import { MerchantCustomizableModal } from "@redotech/redo-web/storefront/merchant-customizable-modal";
import { memo, useEffect, useState } from "react";

export const ReviewsSurveyModal = memo(function ReviewsSurveyModal({
  reviewsFormValue,
}: {
  reviewsFormValue: ReviewsFormValue;
}) {
  const [open, setOpen] = useState(false);

  const openModalIfRedoReviewsHash = () => {
    if (window.location.hash === REDO_REVIEW_HASH) {
      setOpen(true);
    }
  };

  useEffect(() => {
    openModalIfRedoReviewsHash();
    window.addEventListener("hashchange", openModalIfRedoReviewsHash);

    return () => {
      window.removeEventListener("hashchange", openModalIfRedoReviewsHash);
    };
  }, []);

  const [formData, setFormData] = useState<
    Record<string, PossibleSubmittableData>
  >({});

  const [currentPageIndex, setCurrentPageIndex] = useState(0);

  const handleClose = useHandler(() => {
    // aradford submit data here also - so the merchant doesn't lost partially saved reviews
    if (window.location.hash.includes(REDO_REVIEW_HASH)) {
      const newUrl = new URL(window.location.href);
      newUrl.hash = "";
      window.history.replaceState({}, "", newUrl);
    }
    setOpen(false);
  });

  const handleSubmit = () => {
    // aradford submit data here
    handleClose();
  };

  function handlePageNext() {
    if (currentPageIndex === reviewsFormValue.pages.length - 1) {
      return;
    } else {
      setCurrentPageIndex((prev) => prev + 1);
    }
  }

  function handlePagePrevious() {
    if (currentPageIndex === 0) {
      return;
    } else {
      setCurrentPageIndex((prev) => prev - 1);
    }
  }

  const page = reviewsFormValue.pages[currentPageIndex];

  return (
    <MerchantCustomizableModal onClose={handleClose} open={open}>
      <UploaderContext.Provider
        value={async (file, signal) => {
          // todo bcarper/aradford
          // use uploadFile in /redo/shopify-extension/src/client/shopify-extension-client.ts
          return new URL(
            "https://fastly.picsum.photos/id/491/200/200.jpg?hmac=Zi1sOp0NH_d3eOa3qUg8-oDQJWvIkH8UkrAJZ7l-4wg",
          );
        }}
      >
        {page && (
          <Flex style={{ width: "800px", minWidth: "100%", maxWidth: "75%" }}>
            <Page
              addToFormData={(key, value) => {
                setFormData((prev) => ({ ...prev, [key]: value }));
              }}
              currentPage={currentPageIndex}
              formData={formData}
              maxPageIndex={reviewsFormValue.pages.length - 1}
              next={handlePageNext}
              page={page}
              previous={handlePagePrevious}
              submit={handleSubmit}
            />
          </Flex>
        )}
      </UploaderContext.Provider>
    </MerchantCustomizableModal>
  );
});
